import { Outlet } from "react-router-dom";
import { SidebarProvider } from "../ui";
import { Sidebar } from "./Sidebar";
import { cn } from "@/lib/utils";
import { Header } from "./Header";
import useLayout from "./useLayout";

const Layout = () => {
  const { isMasterData } = useLayout();

  return (
    <>
      <SidebarProvider>
        <div className="flex flex-row">
          <main className="bg-white fixed h-[100%] mt-[50px] hidden lg:block">
            <Sidebar />
          </main>
          <div>
            <Header />
            <div
              className={cn(
                "w-[100vw] mt-[50px] bg-g-10 min-h-[screen-10px] text-start transition-all duration-300 ease-in-out",
                isMasterData
                  ? "lg:w-[calc(100vw-314px)] lg:ml-[314px]"
                  : "lg:w-[calc(100vw-128px)] lg:ml-[128px]"
              )}
            >
              <Outlet />
            </div>
            {/* <footer className="bg-white">Footer</footer> */}
          </div>
        </div>
      </SidebarProvider>
    </>
  );
};

export default Layout;
